import React from 'react';
import { VariantOriginModalMode, VariantOriginType } from './types';

interface OriginOption {
  type: VariantOriginType;
  label: string;
  icon: React.ReactNode;
}

interface OriginSelectionProps {
  onSelect: (type: VariantOriginType) => void;
  /** Modal mode - 'variant' or 'test' */
  mode?: VariantOriginModalMode;
  /** Whether to show the "From an existing variant" option */
  showExistingVariantOption?: boolean;
  /** Whether to show the "From different dynamic page" option */
  showDifferentPageOption?: boolean;
}

const EmptyPageIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5"
  >
    <path
      d="M13.3333 1.66699V4.50033C13.3333 4.77647 13.5572 5.00033 13.8333 5.00033H16.6666M3.33331 2.16699V17.8337C3.33331 18.1098 3.55717 18.3337 3.83331 18.3337H16.1666C16.4428 18.3337 16.6666 18.1098 16.6666 17.8337V4.79077C16.6666 4.65816 16.614 4.53098 16.5202 4.43721L13.8964 1.81344C13.8027 1.71967 13.6755 1.66699 13.5429 1.66699H3.83331C3.55717 1.66699 3.33331 1.89085 3.33331 2.16699Z"
      stroke="#637083"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ExistingVariantIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5"
  >
    <path
      d="M11.6667 18.1C11.9981 18.1 12.2667 17.8314 12.2667 17.5C12.2667 17.1686 11.9981 16.9 11.6667 16.9V17.5V18.1ZM1.66669 5.23333C1.33532 5.23333 1.06669 5.50196 1.06669 5.83333C1.06669 6.1647 1.33532 6.43333 1.66669 6.43333V5.83333V5.23333ZM18.3334 6.43333C18.6647 6.43333 18.9334 6.1647 18.9334 5.83333C18.9334 5.50196 18.6647 5.23333 18.3334 5.23333V5.83333V6.43333ZM3.72071 3.77362C3.49903 4.01993 3.519 4.3993 3.76531 4.62098C4.01162 4.84265 4.39099 4.82268 4.61266 4.57638L4.16669 4.175L3.72071 3.77362ZM4.621 4.56712C4.84267 4.32081 4.8227 3.94144 4.5764 3.71976C4.33009 3.49809 3.95072 3.51806 3.72904 3.76436L4.17502 4.16574L4.621 4.56712ZM6.22071 3.77362C5.99904 4.01992 6.019 4.39929 6.2653 4.62097C6.51161 4.84265 6.89098 4.82269 7.11266 4.57638L6.66669 4.175L6.22071 3.77362ZM7.12099 4.56712C7.34267 4.32082 7.32271 3.94145 7.0764 3.71977C6.8301 3.49809 6.45073 3.51805 6.22905 3.76436L6.67502 4.16574L7.12099 4.56712ZM8.72071 3.77362C8.49904 4.01992 8.519 4.39929 8.7653 4.62097C9.01161 4.84265 9.39098 4.82269 9.61266 4.57638L9.16669 4.175L8.72071 3.77362ZM9.62099 4.56712C9.84267 4.32082 9.82271 3.94145 9.5764 3.71977C9.3301 3.49809 8.95073 3.51805 8.72905 3.76436L9.17502 4.16574L9.62099 4.56712ZM18.3642 16.2215L18.4318 16.8177L18.4318 16.8177L18.3642 16.2215ZM18.4019 15.3043L18.0875 15.8153L18.0875 15.8153L18.4019 15.3043ZM16.2254 16.464L16.1578 15.8678L15.8337 15.9045L15.6883 16.1966L16.2254 16.464ZM15.2661 18.3909L14.729 18.1235L14.729 18.1235L15.2661 18.3909ZM14.3913 18.1125L14.979 17.9919L14.979 17.9919L14.3913 18.1125ZM13.3452 13.0159L13.9329 12.8952L13.9329 12.8952L13.3452 13.0159ZM13.9704 12.5781L13.656 13.0892L13.656 13.0892L13.9704 12.5781ZM1.66669 4.16667H1.06669V15.8333H1.66669H2.26669V4.16667H1.66669ZM16.6667 2.5V1.9H3.33335V2.5V3.1H16.6667V2.5ZM3.33335 17.5V18.1H11.6667V17.5V16.9H3.33335V17.5ZM18.3334 12.5H18.9334V4.16667H18.3334H17.7334V12.5H18.3334ZM16.6667 2.5V3.1C17.2558 3.1 17.7334 3.57756 17.7334 4.16667H18.3334H18.9334C18.9334 2.91482 17.9185 1.9 16.6667 1.9V2.5ZM1.66669 15.8333H1.06669C1.06669 17.0852 2.08151 18.1 3.33335 18.1V17.5V16.9C2.74425 16.9 2.26669 16.4224 2.26669 15.8333H1.66669ZM1.66669 4.16667H2.26669C2.26669 3.57756 2.74425 3.1 3.33335 3.1V2.5V1.9C2.08151 1.9 1.06669 2.91482 1.06669 4.16667H1.66669ZM1.66669 5.83333V6.43333H18.3334V5.83333V5.23333H1.66669V5.83333ZM4.16669 4.175L4.61266 4.57638L4.621 4.56712L4.17502 4.16574L3.72904 3.76436L3.72071 3.77362L4.16669 4.175ZM6.66669 4.175L7.11266 4.57638L7.12099 4.56712L6.67502 4.16574L6.22905 3.76436L6.22071 3.77362L6.66669 4.175ZM9.16669 4.175L9.61266 4.57638L9.62099 4.56712L9.17502 4.16574L8.72905 3.76436L8.72071 3.77362L9.16669 4.175ZM18.3642 16.2215L18.4318 16.8177C19.006 16.7526 19.2789 16.2774 19.2958 15.8644C19.3122 15.4652 19.1149 15.0385 18.7163 14.7932L18.4019 15.3043L18.0875 15.8153C18.1003 15.8232 18.0962 15.8311 18.0968 15.8152C18.0972 15.8047 18.1017 15.7638 18.1408 15.7155C18.1609 15.6908 18.1873 15.6681 18.2184 15.6513C18.2495 15.6344 18.2776 15.6275 18.2967 15.6253L18.3642 16.2215ZM16.2254 16.464L16.293 17.0601L18.4318 16.8177L18.3642 16.2215L18.2967 15.6253L16.1578 15.8678L16.2254 16.464ZM15.2661 18.3909L15.8032 18.6583L16.7625 16.7314L16.2254 16.464L15.6883 16.1966L14.729 18.1235L15.2661 18.3909ZM14.3913 18.1125L13.8035 18.2332C13.8976 18.6916 14.2312 19.023 14.6119 19.1441C15.0058 19.2695 15.5457 19.1755 15.8032 18.6583L15.2661 18.3909L14.729 18.1235C14.7375 18.1063 14.7536 18.0823 14.7801 18.0588C14.8066 18.0353 14.8369 18.0183 14.867 18.0079C14.9257 17.9876 14.9657 17.9974 14.9757 18.0006C14.9908 18.0054 14.982 18.0067 14.979 17.9919L14.3913 18.1125ZM13.3452 13.0159L12.7574 13.1365L13.8035 18.2332L14.3913 18.1125L14.979 17.9919L13.9329 12.8952L13.3452 13.0159ZM13.9704 12.5781L14.2847 12.0671C13.9343 11.8515 13.4964 11.8344 13.1524 12.0753C12.8084 12.3161 12.6747 12.7335 12.7574 13.1365L13.3452 13.0159L13.9329 12.8952C13.9325 12.8928 13.9371 12.9152 13.9238 12.9522C13.9104 12.9891 13.8831 13.0286 13.8407 13.0582C13.7984 13.0879 13.7519 13.1001 13.7126 13.1C13.6733 13.0999 13.6539 13.0879 13.656 13.0892L13.9704 12.5781ZM18.4019 15.3043L18.7163 14.7932L14.2847 12.0671L13.9704 12.5781L13.656 13.0892L18.0875 15.8153L18.4019 15.3043Z"
      fill="#637083"
    />
  </svg>
);

const DifferentPageIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5"
  >
    <path
      d="M8.33335 9.39967C8.00198 9.39967 7.73335 9.6683 7.73335 9.99967C7.73335 10.331 8.00198 10.5997 8.33335 10.5997V9.99967V9.39967ZM9.16669 10.5997C9.49806 10.5997 9.76669 10.331 9.76669 9.99967C9.76669 9.6683 9.49806 9.39967 9.16669 9.39967V9.99967V10.5997ZM4.16669 5.23301C3.83532 5.23301 3.56669 5.50164 3.56669 5.83301C3.56669 6.16438 3.83532 6.43301 4.16669 6.43301V5.83301V5.23301ZM5.00002 6.43301C5.33139 6.43301 5.60002 6.16438 5.60002 5.83301C5.60002 5.50164 5.33139 5.23301 5.00002 5.23301V5.83301V6.43301ZM5.83335 9.16634H5.23335V15.833H5.83335H6.43335V9.16634H5.83335ZM7.50002 17.4997V18.0997H16.6667V17.4997V16.8997H7.50002V17.4997ZM18.3334 15.833H18.9334V9.16634H18.3334H17.7334V15.833H18.3334ZM16.6667 7.49967V6.89967H7.50002V7.49967V8.09967H16.6667V7.49967ZM18.3334 9.16634H18.9334C18.9334 7.9145 17.9185 6.89967 16.6667 6.89967V7.49967V8.09967C17.2558 8.09967 17.7334 8.57724 17.7334 9.16634H18.3334ZM16.6667 17.4997V18.0997C17.9185 18.0997 18.9334 17.0849 18.9334 15.833H18.3334H17.7334C17.7334 16.4221 17.2558 16.8997 16.6667 16.8997V17.4997ZM5.83335 15.833H5.23335C5.23335 17.0849 6.24817 18.0997 7.50002 18.0997V17.4997V16.8997C6.91092 16.8997 6.43335 16.4221 6.43335 15.833H5.83335ZM5.83335 9.16634H6.43335C6.43335 8.57724 6.91092 8.09967 7.50002 8.09967V7.49967V6.89967C6.24817 6.89967 5.23335 7.9145 5.23335 9.16634H5.83335ZM1.66669 4.99967H1.06669V11.6663H1.66669H2.26669V4.99967H1.66669ZM12.5 3.33301V2.73301H3.33335V3.33301V3.93301H12.5V3.33301ZM3.33335 13.333V13.933H5.41669V13.333V12.733H3.33335V13.333ZM14.1667 7.49967H14.7667V4.99967H14.1667H13.5667V7.49967H14.1667ZM12.5 3.33301V3.93301C13.0891 3.93301 13.5667 4.41057 13.5667 4.99967H14.1667H14.7667C14.7667 3.74783 13.7519 2.73301 12.5 2.73301V3.33301ZM1.66669 11.6663H1.06669C1.06669 12.9182 2.08151 13.933 3.33335 13.933V13.333V12.733C2.74425 12.733 2.26669 12.2554 2.26669 11.6663H1.66669ZM1.66669 4.99967H2.26669C2.26669 4.41057 2.74425 3.93301 3.33335 3.93301V3.33301V2.73301C2.08151 2.73301 1.06669 3.74783 1.06669 4.99967H1.66669ZM8.33335 9.99967V10.5997H9.16669V9.99967V9.39967H8.33335V9.99967ZM4.16669 5.83301V6.43301H5.00002V5.83301V5.23301H4.16669V5.83301Z"
      fill="#637083"
    />
  </svg>
);

const ControlVariationIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5"
  >
    <path
      d="M10 1.66699V3.33366M10 16.667V18.3337M3.33334 10.0003H1.66667M5.26334 5.26366L4.08334 4.08366M14.7367 5.26366L15.9167 4.08366M5.26334 14.7437L4.08334 15.917M14.7367 14.7437L15.9167 15.917M18.3333 10.0003H16.6667M14.1667 10.0003C14.1667 12.302 12.3017 14.167 10 14.167C7.69834 14.167 5.83334 12.302 5.83334 10.0003C5.83334 7.69866 7.69834 5.83366 10 5.83366C12.3017 5.83366 14.1667 7.69866 14.1667 10.0003Z"
      stroke="#637083"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const variantModeOptions: OriginOption[] = [
  {
    type: 'empty',
    label: 'Start fresh',
    icon: <EmptyPageIcon />,
  },
  {
    type: 'existingVariant',
    label: 'Copy from another variant',
    icon: <ExistingVariantIcon />,
  },
  {
    type: 'differentDynamicPage',
    label: 'Copy from another page',
    icon: <DifferentPageIcon />,
  },
];

const testModeOptions: OriginOption[] = [
  {
    type: 'controlVariation',
    label: 'Start from control',
    icon: <ControlVariationIcon />,
  },
  {
    type: 'empty',
    label: 'Start fresh',
    icon: <EmptyPageIcon />,
  },
  {
    type: 'existingVariant',
    label: 'Copy from another variant',
    icon: <ExistingVariantIcon />,
  },
  {
    type: 'differentDynamicPage',
    label: 'Copy from another page',
    icon: <DifferentPageIcon />,
  },
];

export function OriginSelection({
  onSelect,
  mode = 'variant',
  showExistingVariantOption = true,
  showDifferentPageOption = true,
}: OriginSelectionProps) {
  // Choose options based on mode
  const baseOptions = mode === 'test' ? testModeOptions : variantModeOptions;

  // Filter options based on props
  const visibleOptions = baseOptions.filter((option) => {
    if (option.type === 'existingVariant' && !showExistingVariantOption) {
      return false;
    }
    if (option.type === 'differentDynamicPage' && !showDifferentPageOption) {
      return false;
    }
    return true;
  });

  return (
    <div className="flex w-full flex-col gap-3">
      {visibleOptions.map((option) => (
        <button
          key={option.type}
          type="button"
          onClick={() => onSelect(option.type)}
          className="rounded-2lg flex items-center gap-2.5 self-stretch border border-[#e4e7ec] bg-white px-4 py-3 transition-colors hover:bg-[#f9fafb]"
          style={{ boxShadow: '0px 1px 2px 0 rgba(21,28,36,0.05)' }}
        >
          {option.icon}
          <span className="text-base-900 text-sm">{option.label}</span>
        </button>
      ))}
    </div>
  );
}
